import React, { useState } from "react";

export class Conductor {
    /**
     * @type {{ [key: string]: { callback: Function } }}
     */
    listeners = {};

    values = {};

    listen(id, callback) {
        this.listeners[id] = { callback };
    }

    notify() {
        for(const listener of Object.values(this.listeners)) {
            listener.callback();
        }
    }

    detach(id) {
        delete this.listeners[id];
    }

    update(key, value, { silent = false } = {}) {
        this.values[key] = value;
        if(!silent) this.notify();
    }


    setValues(values, { silent = false } = {}) {
        this.values = { ...this.values, ...values };
        if(!silent) this.notify();
    }

    get(key, defaultValue = undefined) {
        return (key in this.values) ? this.values[key] : defaultValue;
    }

}

export function useReference(ref) {
    const obj = {};
    for(const key in ref) {
        const value = ref[key];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const state = useState(value);
        Object.defineProperty(obj, key, {
            get: () => state[0],
            set: (value) => {
                state[1](value);
            }
        });
    }

    return obj;
}

/** A shorthand for handling single-valued conductors  */
export class Notifier extends Conductor {
    constructor(initialValue) {
       super();
       super.update("_default", initialValue, { silent: true });
    }

    update(value, { silent = false } = {}) {
        super.update("_default", value, { silent });
    } 

    get() {
        return super.get("_default");
    }
}


export class Dynamic extends React.Component {
    static idCounter = 0;

    state = {};

    constructor(props) {
        super(props);

        this.id = (Dynamic.idCounter++) + "";
        this.child = props.child;

        if(props.conductor) {
            const conductors = Array.isArray(props.conductor) ? props.conductor : [props.conductor];
            for(const conductor of conductors) {
                if(conductor) conductor.listen(this.id, () => {
                        if(this._mounted) this.forceUpdate();
                    });
            }

            this.conductors = conductors;
        }
    }

    componentDidMount () {
        this._mounted = true;
    }
    componentWillUnmount () {
        this._mounted = false;
    }

    render() {
        return this.child();
    }
}